import { useMsal } from "@azure/msal-react";
import { useQuery, useMutation } from 'react-query';
import axios from 'axios';
import { loginRequest, apiRequest } from "../authConfig";

const LOGIN_URL = `${apiRequest.server}/login`;

// login requests the access token (MSAL is already logged in)
// and sends it to the api login to start session
const useLoginQuery = () => {
    const { instance, accounts } = useMsal();
    const request = {...loginRequest, account: accounts[0]};

    const query = async (accessToken) => {
        const {data} = await axios.get(LOGIN_URL,
            { 
                withCredentials: true,
                headers: { Authorization: `Bearer ${accessToken}` }
            });
        return data;
        };

    return useQuery('login',
        async () => {
            try {
                const response = await instance.acquireTokenSilent(request);
                return query(response.accessToken);
            } catch (e) {
                const response = await instance.acquireTokenPopup(request);
                return query(response.accessToken);
            }
        });
};

// general queries rely on the session for authentication (separated for on-demand use)
const sessionQuery = async (path) => {
    const {data} = await axios.get(`${apiRequest.server}${path}`,
                                    { withCredentials: true });
    return data;
};

const useSessionQuery = (path) => {
    return useQuery(path, async () => sessionQuery(path));
};

const useSessionMutation = (subpath) => {
    return useMutation(async data => {
        const response = await axios.post(`${apiRequest.server}${subpath}`, data,
                                            { withCredentials: true });
        return response;
    });
};

const mutationErrorMsg = ((mutation, text) => {
    if (mutation && mutation.isError) {
        // http codes
        if (mutation.error.response) {
            if (mutation.error.response.status === 401) {
                return `${text}: 401 Unauthorized`;
            }
            return `${text}: ${mutation.error.response.status}`;
        } else {
            return `${text}: No response from server`;
        }
    }
    return null;
});

export { useLoginQuery, useSessionQuery, useSessionMutation, mutationErrorMsg };
